import { Handle, Position } from "reactflow";
import * as Icons from "lucide-react";
import { SIMPLE_CATEGORY_COLORS } from "@/constants/archimate";

const HANDLE_STYLE = { width: 1, height: 1, opacity: 0, pointerEvents: "none" };

export function SimpleNode({ data }) {
  const colors = SIMPLE_CATEGORY_COLORS[data.category] || SIMPLE_CATEGORY_COLORS.Other;
  const Icon = Icons[colors.icon] || Icons.Circle;

  return (
    <div
      data-testid={`simple-node-${data.category.toLowerCase()}`}
      title={data.name}
      className="h-full w-full rounded-lg border-2 shadow-sm flex flex-col overflow-hidden"
      style={{ background: colors.bg, borderColor: colors.border }}
    >
      <Handle id="top" type="target" position={Position.Top} style={HANDLE_STYLE} />
      <Handle id="left" type="target" position={Position.Left} style={HANDLE_STYLE} />
      <Handle id="right" type="source" position={Position.Right} style={HANDLE_STYLE} />
      <Handle id="bottom" type="source" position={Position.Bottom} style={HANDLE_STYLE} />
      <div className="flex items-center gap-1.5 px-2 py-1 border-b" style={{ borderColor: colors.border, background: "rgba(255,255,255,0.4)" }}>
        <Icon size={12} style={{ color: colors.text }} />
        <span className="text-[9px] font-semibold uppercase tracking-wide truncate" style={{ color: colors.text }}>
          {data.category}
        </span>
      </div>
      <div className="flex-1 px-2 py-1.5 text-xs font-semibold leading-snug flex items-center" style={{ color: colors.text }}>
        {data.name}
      </div>
    </div>
  );
}
